import React, { useState, useEffect } from 'react';
import ChatWindow from './ChatWindow';
import TeamchatScreen from '../Chat/TeamchatScreen';
import { updateEmployeeStatus } from '../services/firestoreService';
import './ChatScreen.css';

const ChatScreen = ({ onClose, employeeData, allMessages }) => {
  const [chatMode, setChatMode] = useState('support'); // 'support' or 'team'

  // Update employee status when chat screen opens/closes
  useEffect(() => {
    const employeeId = employeeData?._id;
    
    if (!employeeId) {
      return;
    }

    // Set status to online when chat screen opens
    updateEmployeeStatus(employeeId, 'online').catch(error => {
      console.error('Error updating employee status to online:', error);
    });

    // Cleanup: Set status to offline when component unmounts (chat screen closes)
    return () => {
      if (employeeId) {
        updateEmployeeStatus(employeeId, 'offline').catch(error => {
          console.error('Error updating employee status to offline:', error);
        });
      }
    };
  }, [employeeData?._id]);

  // Handle close with status update
  const handleClose = async () => {
    const employeeId = employeeData?._id;
    if (employeeId) {
      try {
        await updateEmployeeStatus(employeeId, 'offline');
      } catch (error) {
        console.error('Error updating employee status to offline:', error);
      }
    }
    onClose();
  };

  return (
    <div className="chat-screen-overlay" onClick={handleClose}>
      <div className="chat-screen-container" onClick={(e) => e.stopPropagation()}>
        <div className="chat-screen-header">
          <div className="chat-mode-selector">
            <button
              className={`mode-button ${chatMode === 'support' ? 'active' : ''}`}
              onClick={() => setChatMode('support')}
            >
              💬 Support Chat
            </button>
            <button
              className={`mode-button ${chatMode === 'team' ? 'active' : ''}`}
              onClick={() => setChatMode('team')}
            >
              👥 Team Chat
            </button>
          </div>
          <button className="chat-screen-close-btn" onClick={handleClose}>×</button>
        </div>
        <div className="chat-screen-content">
          {chatMode === 'support' ? (
            <ChatWindow
              onClose={handleClose}
              employeeData={employeeData}
              allMessages={allMessages}
            />
          ) : (
            <TeamchatScreen onClose={handleClose} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatScreen;



